export enum HttpHeaders {
  AkamaiBot = 'akamai-bot',
  AkamaiCdnAclBypass = 'x-aka-secret',
  Authorization = 'Authorization',
  ChewyAuthAccessToken = 'X-Chewy-Auth-Access-Token',
  ChewyAuthSessionId = 'X-Chewy-Auth-Session-Id',
  ChewyToken = 'X-Chewy-Auth-ID-Token',
  XChewyAuthActionToken = 'X-Chewy-Auth-Action-Token',
  ContentType = 'Content-Type',
  LegacyProxy = 'x-account-ui-legacy',
  PersonalizationId = 'x-personalization-id',
  Pragma = 'pragma',
  RequestId = 'x-request-id',
  SetCookie = 'set-cookie',
  StackId = 'x-stack-id',
  UserAgent = 'user-agent',
  XOriginUserAgent = 'x-origin-user-agent',
  Cookie = 'cookie',
  AkamaiBotSBSD = 'akamai-bot-sbsd',
  AkamaiEdgescape = 'x-akamai-edgescape',
  TrueClientIp = 'true-client-ip',
  XChewyInternal = 'x-chewy-internal',
  XAkamaiEdgescape = 'x-akamai-edgescape',
  XForwardedFor = 'x-forwarded-for',
  KasadaRequestId = 'x-kasada-request-id',
  KasadaClientId = 'x-kasada-client-id',
  KasadaClassification = 'x-kasada-classification',
  NMALinkerId = 'nmaLinkerId',
}

export const PAYMENTS_CALLER_ID = 'loyalty-web';
